import { useEffect, type MouseEvent, useState } from "react";
import { useUser } from "../../../../contexts/userContext/userContext";
import { useCookie } from "../../../../contexts/cookieContext/cookieContext";

const useSpecialNotification = () => {
  const { isSubscribed } = useUser();
  const { getCookie } = useCookie();
  const [displaySpecialNotification, setDisplaySpecialNotification] =
    useState(false);
  const [destinationUrl, setDestinationUrl] = useState("");

  useEffect(() => {
    const handleBeforeUnload = (event: MouseEvent) => {
      const target = event.target as HTMLAnchorElement;
      const navigate = target.getAttribute("data-navigate");
      //check if exists cookie
      const existsCookie = getCookie("ActiveUserPromotion");
      const activeUserPromotionCookieValue = existsCookie || null;
      const destinationUrlEvent = target.href; // Save the destination URL in a variable
      const isPurchaseRedirect =
        (destinationUrlEvent != null &&
          destinationUrlEvent.includes("purchase")) ||
        (destinationUrlEvent != null &&
          destinationUrlEvent.includes("registration"))
          ? true
          : false;
      if (
        navigate === "true" &&
        activeUserPromotionCookieValue &&
        !isPurchaseRedirect &&
        !isSubscribed()
      ) {
        event.preventDefault();
        setDisplaySpecialNotification(true);
        setDestinationUrl(destinationUrlEvent);
      } else {
        //continue with the navigation
        return;
      }
    };

    window.addEventListener("click", handleBeforeUnload as any);

    return () => {
      window.removeEventListener("click", handleBeforeUnload as any);
    };
  }, []);

  return {
    displaySpecialNotification,
    destinationUrl,
  };
};

export default useSpecialNotification;
